<template>
 <div>

   <!--div v-if="!isHidden"-->
   <div v-if="isHidden">
     <div v-if="!mapIsHidden" class="map">
       <br>
        <h1>Lingua Destinazione</h1>
        <v-select :options="langs" v-model="dest_lang" label="description" name="langs" placeholder="Seleziona la tua lingua"></v-select>
        <br>
        <h1>Lingua Sorgente</h1>
        <br>
        <radio-svg-map :map="World" v-model="selectedLocation" @click="onClick"/>
      </div>
      <div v-if="mapIsHidden">
        <br>
        <h1>{{selectedLocation}}</h1>
        <br>
        <b-container fluid="sm">
          <b-overlay :show="show" rounded="sm">
          <b-row>
            <b-col cols="3">
              <div v-if="selectedLocation === 'africa'">
                <radio-svg-map :map="World" style="width: 100%;" @click="indietro"/>
              </div>
              <div v-else-if="selectedLocation === 'europe'">
                <radio-svg-map :map="World" style="width: 100%;"  @click="indietro"/>
              </div>
              <div v-else-if="selectedLocation === 'Asia'">
                <radio-svg-map :map="World" style="width: 100%;"  @click="indietro"/>
              </div>
              <div v-else-if="selectedLocation === 'Australia'">
                <radio-svg-map :map="World" style="width: 100%;"  @click="indietro"/>
              </div>
              <div v-else-if="selectedLocation === 'South America'">
                <radio-svg-map :map="World" style="width: 100%;"  @click="indietro"/>
              </div>
              <div v-else-if="selectedLocation === 'North America'">
                <radio-svg-map :map="World" style="width: 100%;"  @click="indietro"/>
              </div>

            </b-col>
            <b-col cols="3">
              <b-form-group v-for="lang in countryLangs" :key="lang.id">
                <b-form-radio stacked v-model="src_lang" name="some-radios" :value="lang">{{lang.description}}

                <audio controls="controls" :src="lang.blobUrl">
                  Il tuo browser non supporta l'audio
                </audio>
              </b-form-radio>
            </b-form-group>
            </b-col>
          </b-row>
          </b-overlay>
        </b-container>

      </div>

      <br>
      <b-button v-if="mapIsHidden" variant="warning" @click="indietro" style="margin-right:10px;">Indietro</b-button>
      <b-button variant="success" @click="translate" >Avanti</b-button>
    </div>

    <div v-if="isHidden" class="translate">
      <div class="source">
        <div class="info">
          <b-img
            align-self="center"
            src="https://img.icons8.com/external-bearicons-glyph-bearicons/64/000000/external-User-essential-collection-bearicons-glyph-bearicons.png"
            v-bind="mainProps"
            rounded="circle"
          />
          <h2>Utente</h2>
          <hr>
          <span style="float: left;">Lingua: {{src_lang.description}}</span>
        </div>
        <div class="audio">
          <VueRecordAudio mode="hold" @result="srcRecord" class="mx-auto" /><br>

          <div v-if="src_audioBlob != null" style="overflow-y: scroll; height: 200px;">
            <div v-for="blob in this.src_audioBlob" :key="blob.id">
              <audio controls="controls" :src="blob.blob">
                Il tuo browser non supporta l'audio
              </audio>
              <span style="color: gray;">{{blob.time}}</span>
            </div>
          </div>

          <div v-if="userSpinnerShow">
            <span>traduzione in corso...</span><br>
            <b-spinner variant="success" label="Spinning"></b-spinner>
            <b-spinner type="grow" variant="success" label="Spinning"></b-spinner>
          </div>
          <!--audio-recorder upload-url="https://127.0.0.1:443/languageaid-api-endpoint/languages/audio/upload" :successful-upload="callback" :failed-upload="callback" /-->

        </div>
      </div>

      <div class="dest">
        <div class="info">
          <b-img
            v-if="organization.image !== null"
            align-self="center"
            :src="logo(organization)"
            v-bind="mainProps"
            rounded="circle"
          />
          <b-img v-else v-bind="emptyProps" rounded="circle"/>
          <h2>{{organization.name}}</h2>
          <hr>
          <span style="float: left;">Operatore: {{user.first_name}} {{user.last_name}}</span><br>
          <span style="float: left;">Lingua: {{dest_lang.description}}</span>
        </div>
        <div class="audio">
          <VueRecordAudio mode="hold" @result="destRecord" class="mx-auto" /><br>
          <div v-if="dest_audioBlob != null" style="overflow-y: scroll; height: 200px;">
            <div v-for="blob in this.dest_audioBlob" :key="blob.id">
              <audio controls="controls" :src="blob.blob">
                Il tuo browser non supporta l'audio
              </audio>
              <span style="color: gray;">{{blob.time}}</span>
            </div>
          </div>
          <div v-if="orgSpinnerShow">
            <span>traduzione in corso...</span><br>
            <b-spinner variant="success" label="Spinning"></b-spinner>
            <b-spinner type="grow" variant="success" label="Spinning"></b-spinner>
          </div>
        </div>
        <b-button variant="danger" @click="$bvModal.show('modal-3');" style="margin-top: 20%;">Termina l'interazione</b-button>
        <b-modal id="modal-3" title="Torna indietro" @ok="endCom">
          <p>Sei sicuro?</p>
        </b-modal>
        </div>
    </div>

    <!-- Seleziona TextToText oppure VoiceToVoice -->
    <!-- <div v-if="toggle" style="height: 100vh;">

      <div class="textToText" style="display: flex; align-items: center; justify-content: center;">
        <div style="cursor: pointer;" @click="showTextToText">
          <img src="/iconss/traduttori.png" class="mt-2" />
          <h1 style="padding-top: 10px;"><b style="color: silver;">Text to Text</b></h1>
        </div>
      </div>
      
      <div class="voiceToVoice" style="display: flex; align-items: center; justify-content: center;">
        <div style="cursor: pointer; margin-top: auto; margin-bottom: auto;" @click="showVoiceToVoice">
          <img src="/iconss/traduttori.png" class="mt-2" />
          <h1 style="padding-top: 10px;"><b style="color: silver;">Voice to Voice</b></h1>
        </div>
      </div>

    </div> -->


    <!-- TextToText -->
    <!-- <div v-if="isTextToText">
      <VoiceToVoice mod='textToText'></VoiceToVoice>
    </div> -->

    <!-- VoiceToVoice -->
    <!-- <div v-if="isVoiceToVoice">
      <VoiceToVoice mod='voiceToVoice'></VoiceToVoice>
    </div> -->
    <VoiceToVoice mod='voiceToVoice'></VoiceToVoice>

  </div>
</template>

<script>
import UserService from "@/services/user.service";
import { RadioSvgMap } from "vue-svg-map";
import World from "@svg-maps/world";
import VoiceToVoice from "@/components/VoiceToVoice";

export default {
    name: "ppt",
    components: { RadioSvgMap, VoiceToVoice,},
    data() {
      return {
        isVoiceToVoice: false,
        isTextToText: false,
        toggle: true,
        organization: [],
        mainProps: {
          blankColor: "#777",
          width: 125,
          height: 125,
          class: "m1",
        },
        emptyProps: {
          blank: true,
          blankColor: "#777",
          width: 125,
          height: 125,
          class: "m1",
        },
        user: null,
        fields: [{key: 'description',}],
        World,
        selectedLocation: null,
        isHidden: false,
        mapIsHidden: false,
        langs: [],
        countryLangs: [],
        src_lang: null,
        dest_lang: null,
        src_audioBlob: [],
        dest_audioBlob: [],
        selected: null,
        id: null,
        show: true,
        userSpinnerShow: false,
        orgSpinnerShow: false,
        i: 0,
      }
    },
    methods: {
      showTextToText(){
        this.isTextToText = true;
        this.toggle = !this.toggle;
      },
      showVoiceToVoice(){
        this.isVoiceToVoice = true;
        this.toggle = !this.toggle;
      },
      callback (data) {
        console.log("ciao");
        console.log(data);
      },
      logo: function (org) {
        return process.env.VUE_APP_ROOT + "/" + org.image;
      },
      onClick(){
        UserService.getCountryLanguages(this.selectedLocation).then((response) => {
          this.getLang(response.data);
          this.mapIsHidden = !this.mapIsHidden;
        });
      },
      indietro(){
        this.show = true;
        this.countryLangs = [];
        this.mapIsHidden = !this.mapIsHidden;
      },
      setLanguage(item){
        this.src_lang= item;
      },
    async srcRecord(msg) {
        this.i = this.i+1;
        this.userSpinnerShow=true;
        const today = new Date();
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        const time2 = today.getHours() + "-" + today.getMinutes() + "-" + today.getSeconds();
        //this.src_audioBlob.push({blob: URL.createObjectURL(msg), time: time});

        UserService.uploadAudio(this.src_lang.id, this.dest_lang.id, this.id, time2, msg, this.i).then(response => {
            console.log(response);
            UserService.getAudio(response.data.audioRes).then(response =>{
              if(response.ok == false){
                return 'errore';
              }
              console.log(response);
              return response.blob();
            }).then(data=>{
              console.log(data);
              this.userSpinnerShow=false;
              if(data.size == 1 || data == 'errore'){
                this.$bvToast.toast(`Errore nella traduzione dell'audio. Riprova.`, {
                autoHideDelay: 4000,
                solid: true,
                variant:'danger',
                appendToast: false
                })
              }
              else{
              console.log(data);
              this.userSpinnerShow=false;
              this.src_audioBlob.push({blob: URL.createObjectURL(msg), time: time});
              this.dest_audioBlob.push({blob: URL.createObjectURL(data), time: time});
              }
            });

        });

      },
      endCom(){
        UserService.removeAudio(this.id).then((response) => {
          console.log(response);
          this.$router.go();
        });
      },
      async destRecord(msg) {
        //BOX ORGANIZZAZIONE
        this.i = this.i+1;
        this.orgSpinnerShow=true;
        const today = new Date();
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        const time2 = today.getHours() + "-" + today.getMinutes() + "-" + today.getSeconds();
        //this.dest_audioBlob.push({blob: URL.createObjectURL(msg), time: time});

        UserService.uploadAudio(this.dest_lang.id, this.src_lang.id, this.id, time2, msg, this.i).then(response => {

            UserService.getAudio(response.data.audioRes).then(response =>{
              if(response.ok == false){
                return 'errore';
              }
              console.log(response);
              return response.blob();
            }).then(data=>{
              this.orgSpinnerShow=false;
              if(data.size == 1 || data == 'errore'){
                this.$bvToast.toast(`Errore nella traduzione dell'audio. Riprova.`, {
                title: `Errore`,
                autoHideDelay: 4000,
                solid: true,
                variant:'danger',
                appendToast: false
                })
              }
              else{
                console.log(data);
                this.orgSpinnerShow=false;
                this.dest_audioBlob.push({blob: URL.createObjectURL(msg), time: time});
                this.src_audioBlob.push({blob: URL.createObjectURL(data), time: time});
              }
            });

        });

      },
      translate(){
        this.show = true;
        if( this.src_lang == null || this.dest_lang == null ){
          this.$bvToast.toast(`Non hai impostato le lingue correttamente`, {
          title: `Errore`,
          autoHideDelay: 2000,
          solid: true,
          variant:'danger',
          appendToast: false
          })
        }
        else{
          this.id = Math.ceil(Math.random()*10000);
          console.log(this.id);
          this.isHidden=!this.isHidden
        }
      },
      srcaudioBlobUrl(blob){
        return URL.createObjectURL(blob);
      },
      destaudioBlobUrl(blob) {
        return URL.createObjectURL(blob);
      },
      async getLang(langs){
        for (const id of langs){
          console.log(id);

          await UserService.textToSpeech(id.id).then(response => {
            if(response.status == 405)
              return response;
            else
              return response.blob();
          }).then(data => {
            console.log(data);
            if(data.status == 405){
              this.$bvToast.toast(data.statusText, {
              title: "Errore "+data.status,
              autoHideDelay: 4000,
              solid: true,
              variant:'danger',
              appendToast: false
              })
              return 0;
            }
            this.countryLangs.push({
              continent: id.continent,
              default_flag: id.default_flag,
              description: id.description,
              id: id.id,
              blobUrl: URL.createObjectURL(data)
            });
          });

          /*this.countryLangs.push({
            continent: id.continent,
            default_flag: id.default_flag,
            description: id.description,
            id: id.id,
            //blobUrl: URL.createObjectURL(data)
          });*/
          /*await UserService.getAudio('//tmp//audio', id).then(response => {
              return response.blob();
          }).then(data => {
            console.log(data);
            this.countryLangs.push({
              continent: id.continent,
              default_flag: id.default_flag,
              description: id.description,
              id: id.id,
              blobUrl: URL.createObjectURL(data)
            });
          });*/
        }
        this.show = false;
      }

    },
    computed: {
    },
    mounted() {
      UserService.whoAmI()
        .then((response) => {
          this.user = response.data;
          UserService.getOrganizationById(this.user.organization_id).then((response) => (this.organization = response.data));
        })
        .catch((error) => {
          console.log("Whoami: error");
          console.log(error);
          this.$store.dispatch("auth/logout");
          this.$router.push("/login/organization");
        });
      //UserService.getLanguages().then((response) => (this.langs = response.data));
    }
  }

</script>
<style>

.textToText{
  width: 100%;
  height: 50%;
}

.voiceToVoice{
  width: 100%;
  height: 50%;
}

.map{
  margin-left: auto; margin-right: auto;
  width: 80%;
}
.translate{
  margin-top: 20px;
  display: flex;
}
.source{
  margin-left: auto; margin-right: 25px;
  width: 50%;
  border: 1px solid black;
  border-radius: 10px;
  padding: 10px;
}
.info{
  height: 45%;
}
.dest{
  margin-right: auto; margin-left: 25px;
  width: 50%;
  border: 1px solid black;
  border-radius: 10px;
  padding: 10px;
}
.audio{
  align-items: center;
}
</style>
<style src="vue-svg-map/dist/index.css"></style>
